// «➕ رقم تاني» — اختياري (0183، قرار المالك 04/10/2026: «اوقات العميل بيكون ليه رقمين تليفون وخليها اختيار بحيث لو العميل
// معاه تليفون تانى يقدر يزود رقم اخر… العميل اوقات بيبقى الواتس بتاعه رقم والاتصال رقم اخر»).
//
// زرٌّ صغير تحت الرقم الأساسي — لا خانةٌ فارغة تزاحم النموذج لكل عميل. يُضغط فتظهر الخانة، و✕ تشيلها. والخادم يطبّعه ويرفض
// أن يساوي الأساسي.
import { useState } from 'react';
import { Field, TextInput } from './ui.tsx';

export function AltPhoneField({ value, onChange, disabled = false }: {
  value: string; onChange: (v: string) => void; disabled?: boolean;
}) {
  const [shown, setShown] = useState(value.trim() !== '');
  if (!shown) {
    return (
      <div className="flex items-end">
        <button type="button" className="text-sm font-semibold text-brand-700 hover:underline" disabled={disabled}
          onClick={() => setShown(true)}>
          ➕ رقم تاني للعميل
        </button>
      </div>
    );
  }
  return (
    <Field label="رقم تاني" hint="لو العميل ليه رقم واتساب غير رقم الاتصال — اختياري">
      <div className="flex items-center gap-2">
        <TextInput name="altPhone" dir="ltr" inputMode="tel" maxLength={30} value={value} disabled={disabled}
          placeholder="01xxxxxxxxx" onChange={e => onChange(e.target.value)} />
        <button type="button" aria-label="شيل الرقم التاني" className="btn-ghost shrink-0 px-2 py-1 text-sm" disabled={disabled}
          onClick={() => { onChange(''); setShown(false); }}>✕</button>
      </div>
    </Field>
  );
}
